import React from 'react'
import Select from 'react-select'

interface SearchableSelectProps {
  name: string
  required: boolean
  // react-searchにそのまま渡せる形じゃなくてもいいのだが、こうするのがわかりやすい
  options: { value: string, label: string }[]
  defaultValue: string
  // dsだと怒られないがwiiだと「| null」がないと下で怒られる。tsconfigの違いか？
  placeholder?: string | null
  /** 空欄にするボタンの有無（右側に✖ボタンを表示するか） */
  isClearable: boolean | undefined | null
}

function SearchableSelect({ name, required, options, defaultValue, isClearable, placeholder = null }: SearchableSelectProps) {
  // Selectにはlabelも含めた指定が必要
  const _defaultValue = options.find(o => o.value == defaultValue)
  return (
    <Select
      isSearchable={true}
      name={name} required={required} options={options} isClearable={isClearable ?? false} defaultValue={_defaultValue} placeholder={placeholder}
    />
  )
}

export default SearchableSelect
